import { useSelector } from 'react-redux';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';

const STATIC_URL = `${cdnPackagesUrl}/static/cloud/promo/personalization`;

enum PersonalizationSize {
    '256gb' = '256gb',
    '512gb' = '512gb',
    '1tb' = '1tb',
    '2tb' = '2tb',
    '4tb' = '4tb',
}

export const usePersonalizationModalImageUrl = (space?: number): string => {
    const isDarkTheme: boolean = useSelector(isCurrentDarkTheme);

    const getImageUrl = (size: PersonalizationSize) => {
        const theme = isDarkTheme ? 'Dark' : '';
        return `${STATIC_URL}/modal/personalizationModal${size}${theme}.png`;
    };

    switch (space) {
        case 256:
            return getImageUrl(PersonalizationSize['256gb']);
        case 512:
            return getImageUrl(PersonalizationSize['512gb']);
        case 2:
            return getImageUrl(PersonalizationSize['2tb']);
        case 4:
            return getImageUrl(PersonalizationSize['4tb']);
        case 1:
        default:
            return getImageUrl(PersonalizationSize['1tb']);
    }
};
